import { useDeleteClientMutation } from "@graphql/clients/clients.g";
import { ComponentProps } from "react";

import { UpdateClientForm } from "@components/Forms";

import { Card } from "@design-system/Card/Card";
import { Dropdown } from "@design-system/Dropdown/Dropdown";
import { IconButton } from "@design-system/IconButton/IconButton";

type Props = {
  clientId: string;
  onDeleteSuccess: () => void;
  onUpdateClientSuccess: ComponentProps<
    typeof UpdateClientForm
  >["onUpdateClientSuccess"];
};

export const ClientCard = ({
  clientId,
  onDeleteSuccess,
  onUpdateClientSuccess,
}: Props) => {
  const deleteClientMutation = useDeleteClientMutation();
  const deleteClient = deleteClientMutation.mutateAsync;

  const handleDeleteClick = async () => {
    await deleteClient({ clientId });
    onDeleteSuccess?.();
  };

  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Client</Card.Header.Title>
        <Card.Header.Actions>
          <Dropdown trigger={<IconButton icon="faEllipsisVertical" />}>
            <Dropdown.Option
              label="Delete"
              icon="faTrash"
              onSelect={handleDeleteClick}
            />
          </Dropdown>
        </Card.Header.Actions>
      </Card.Header>
      <Card.Body>
        <UpdateClientForm
          clientId={clientId}
          onUpdateClientSuccess={onUpdateClientSuccess}
        />
      </Card.Body>
    </Card>
  );
};
